export default __webpack_public_path__ + "static/media/aboutImg4.9ea36d8b.jpg";